class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    // Cache elements (may be missing on some instances)
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]') || null,
      button: this.querySelector('button') || null,
      panel:  this.querySelector('ul') || null,
      form:   this.querySelector('form') || null,
    };

    // If required parts aren’t present, bail gracefully
    if (!this.elements.button || !this.elements.panel) return;

    // Bind once
    this.onItemClick       = this.onItemClick.bind(this);
    this.openSelector      = this.openSelector.bind(this);
    this.closeSelector     = this.closeSelector.bind(this);
    this.onContainerKeyUp  = this.onContainerKeyUp.bind(this);

    // Wire events
    this.elements.button.addEventListener('click', this.openSelector);
    this.elements.button.addEventListener('focusout', this.closeSelector);
    this.addEventListener('keyup', this.onContainerKeyUp);
    this.querySelectorAll('a').forEach(a => a.addEventListener('click', this.onItemClick));
  }

  hidePanel() {
    if (!this.elements.button || !this.elements.panel) return;
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', '');
  }

  onContainerKeyUp(event) {
    const key = (event.key || event.code || '').toLowerCase();
    if (key !== 'escape') return;
    this.hidePanel();
    this.elements.button && this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    if (this.elements.input) {
      this.elements.input.value = event.currentTarget.dataset.value || '';
    }
    (this.elements.form || this.querySelector('form'))?.submit();
  }

  openSelector() {
    if (!this.elements.button || !this.elements.panel) return;
    const expanded = this.elements.button.getAttribute('aria-expanded') === 'true';
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (!expanded).toString());
    this.elements.button.focus();
  }

  closeSelector(event) {
    if (!this.elements.button || !this.elements.panel) return;
    const rt = event.relatedTarget;
    const shouldClose = !rt || rt.nodeName === 'BUTTON';
    if (shouldClose) this.hidePanel();
  }
}

customElements.define('localization-form', LocalizationForm);
